import { colors } from '@mui/material'
import React from 'react'
import swal from 'sweetalert';


export default function Mindpart() {
  return (
    <div>

<div class="btn-group-vertical" role="group" aria-label="Vertical button group" id='button_group_color'>
  <button type="button" id='sec_one'>Frontal lobe</button>
  <button type="button" id='sec_two'>Parietal lobe</button>
  <button type="button" id='sec_three'>Cerebellum</button>
  <button type="button" id='sec_four'>Occipital lobe</button>
  <button type="button" id='sec_five'>Temporal lobe</button>
  </div>

    </div>
  )
}
